// extracted by css-extract-rspack-plugin
export default {"path":"k7mpC","slash":"CgqCb","item":"BUwkZ","dots":"Q9mAN"};